import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      "Contains Account: A financial account in the institution's general ledger.",
    name: 'General Ledger Accounts',
    partialId: PartialId.Standard.create('gl_accts'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
